import Component from './src/index.vue';
import { AnnounceItem } from './src/type';


export default Component;

export {
  AnnounceItem,
};
